import React, { ReactNode } from 'react';
import Container from '@amzn/awsui-components-console/container';
import ColumnLayout from '@amzn/awsui-components-console/column-layout';
import Link from '@amzn/awsui-components-console/link';
import Alert from '@amzn/awsui-components-console/alert';
import Popover from '@amzn/awsui-components-console/popover';
import StatusIndicator from '@amzn/awsui-components-console/status-indicator';
import Button from '@amzn/awsui-components-console/button';
import ShowSnowStatus from 'src/components/findEntity/ShowSNOWStatus';
import { KeyValue } from 'src/components/commonComponents/KeyValue';
import { getDateAndTimeFromEpoch } from 'src/utils/CommonUtils.jsx';
import WorkflowIntentionDisplay from '../commonComponents/WorkflowIntentionDisplay/WorkflowIntentionDisplay';
import { formatYesNo } from 'src/utils/StringUtils';

function generateUserLink(user) {
	const userLink = `https://phonetool.amazon.com/users/${user}`;

	return (
		<Link external href={userLink}>
			{user}
		</Link>
	);
}

function generateBindleLink(bindleId) {
	const bindleLink = `https://bindles.amazon.com/resource/${bindleId}`;

	return (
		<Link external href={bindleLink}>
			Bindle
		</Link>
	);
}

function copyToScreen(bindleId) {
	return (
		<Popover
			size="small"
			position="top"
			triggerType="custom"
			dismissButton={false}
			content={
				<StatusIndicator type="success">Bindle Id copied</StatusIndicator>
			}
		>
			{bindleId}
			<Button
				data-testid="copy-button"
				iconName="copy"
				variant="icon"
				onClick={() => {
					navigator.clipboard.writeText(bindleId);
				}}
			></Button>
		</Popover>
	);
}

export default function WorkflowDetails({ workflowData, show = true }) {
	const keyValueMap = {
		'Workflow Definition Name': workflowData.workflowDefinitionName,
		Domains: workflowData.domains?.toString(),
		Status: <ShowSnowStatus status={workflowData.status} />,
		'Workflow Id': workflowData.workflowId,
		'Entity Type': workflowData.entityType,
		'Workflow Intention':
			(<WorkflowIntentionDisplay intention={workflowData.workflowIntention} />),
		'Re-Run Allowed': formatYesNo(workflowData.isReRunAllowed),
		'Created By': generateUserLink(workflowData.createdBy),
		'Created At': getDateAndTimeFromEpoch(workflowData.createdAt),
		'Last Updated By': generateUserLink(workflowData.lastUpdatedBy),
		'Last Update Time': getDateAndTimeFromEpoch(workflowData.lastUpdateTime),
		'Supported Tasks': workflowData.supportedTasks?.toString(),
		'Bindle Id': copyToScreen(workflowData.bindleId),
		...(workflowData.derivedFromId && {
			'Derived From Workflow': workflowData.derivedFromId,
		}),
	};

	return show ? (
		<div>
			<Alert
				statusIconAriaLabel="Info"
				action={generateBindleLink(workflowData.bindleId)}
				header="Review Permissions"
			>
				Please note that you must be added to the bindle in order to gain access
				to the workflow.
			</Alert>
			<br />
			<Container>
				<KeyValue label='Description'> {workflowData.description} </KeyValue>
				<br />
				<ColumnLayout columns={3} variant="text-grid">
					{Object.entries(keyValueMap).map(([label, value]) => (
						<KeyValue label={label} key={label}>
							{value as ReactNode}
						</KeyValue>
					))}
				</ColumnLayout>
			</Container>
		</div>
	) : (
		<div></div>
	);
}
